export default __webpack_public_path__ + "static/media/59.3b1ee110.jpeg";